import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
      navigate("/signin");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  return logout;
};

export default useLogout;
